const DEMO_USER_EMAIL = 'demo@rodeo-app.nl'
const EXPORT_PATH = '../../../src/data/demo/'

const LOGGER = console

const COLLECTIONS = [

  // user and team documents will be created before these collections

  { name: 'team' },

  // needs: teamId, userId
  { name: 'userteam' },

  // needs: teamId
  { name: 'contact' },

  // needs: teamId, createdById, contactId
  { name: 'project' },

  // needs: teamId, projectId, createdById, contactId
  {
    name: 'estimate',
    skipEmpty: ['reviewedOn', 'referenceNumber']
  },

  // needs: teamId, estimateId
  { name: 'estimateitem' },

  // needs: teamId, userId, projectId
  { name: 'projectuser' },

  // needs: teamId, contactId, projectId
  { name: 'projectbudgetitem' },

  // needs: teamId, contactId, projectId, createdById
  { name: 'purchaseorder' },

  // needs: teamId, contactId, projectId , budgetItemId, purchaseOrderId
  { name: 'projectbudgetitemsupplier' },

  // needs: teamId, purchaseOrderId, projectId, contactId, budgetItemId, budgetItemSupplierId
  { name: 'purchaseorderitem' },

  // needs: teamId
  { name: 'ratecard' },

  // needs: teamId, createdById, contactId, projectId
  { name: 'invoicetemplate' },

  // needs: teamId, invoiceTemplateId
  { name: 'invoicetemplateitem' },

  // needs: teamId, createdById, contactId, projectId, estimateId, purchaseOrderId
  { name: 'invoice', skipEmpty: ['parentNo'] },

  // needs: teamId, contactId, createdById
  { name: 'expense' },

  // needs: teamId, invoiceId, invoiceTemplateItemId, budgetItemId
  { name: 'invoiceitem' },

  // needs: teamId, expenseId, projectId, contactId, budgetItemId, budgetItemSupplierId, invoiceId
  { name: 'expenseitem' },

  // needs: teamId, userId, projectId
  { name: 'projectactivity' },

  // needs: teamId, userId, projectId, activityId
  { name: 'userprojectactivity' },

  // needs: teamId, userId, projectId, activityId
  { name: 'projectplannertask' },

  // needs: teamId, userId, projectId, activityId, taskId, invoiceId
  { name: 'timecard' },

  // needs: teamId, userId, invoiceId, invoiceItemId, budgetItemId, expenseId, expenseItemId, timecardId
  { name: 'invoiceitemexpense' },

  // needs: teamId, userId
  { name: 'userscheduleoption' },

  // needs: teamId
  { name: 'tag' },

  // needs: teamId, userId, projectId, activityId
  { name: 'timecardfavorite' },

  // needs: teamId, projectId
  { name: 'projectstat' },

  // needs: teamId, userId
  { name: 'taxrate' },

  // teamId
  { name: 'pdftemplate' }
]

module.exports = {
  EXPORT_PATH,
  LOGGER,
  COLLECTIONS,
  DEMO_USER_EMAIL
}
